"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var authConfig_1 = require("../../../authConfig");
var reactstrap_1 = require("reactstrap");
/*import { Line } from 'react-chartjs-2';*/
var react_chartjs_2_1 = require("react-chartjs-2");
var classnames_1 = require("classnames");
require("../../../styles/CustomerListPage.css");
require("../../../styles/ticket.css");
require("../../../styles/Dashboard.css");
var react_1 = require("react");
var customer_1 = require("../../../api/customer");
var dashboard_1 = require("../../../api/dashboard");
var PaginationTable_1 = require("../../PaginationTable");
var HomeBottomSection = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    // Chart Part
    var pichartProps = { type: "", labels: new Array(), datasets: new Array(), options: new Array() };
    var _a = react_1.useState(new Array()), list = _a[0], setList = _a[1];
    var _b = react_1.useState({ customerList: false, dashboardData: false }), isLoaded = _b[0], setIsLoaded = _b[1];
    var _c = react_1.useState('0'), companyChart = _c[0], setCompanyChart = _c[1];
    var _d = react_1.useState({
        total: 0,
        timeToAttend: 0,
        timeToResolution: 0,
        timeToCompletion: 0,
        timeToInitialCall: 0,
        items: new Array(),
    }), dashboardData = _d[0], setDashboardData = _d[1];
    var _e = react_1.useState(pichartProps), piChartData = _e[0], setPiChartData = _e[1];
    var _f = React.useState('monthly'), activeBottomTab = _f[0], setActiveBottomTab = _f[1];
    var toggleBottom = function (tab) {
        /*setActiveBottomTab(tab);*/
        dashboard_1.dashboardBottom(parseInt(companyChart), tab).then(function (response) {
            setDashboardData(response);
            updatePiChart(response);
            setActiveBottomTab(tab);
        }).catch(console.error);
    };
    var updatePiChart = function (dashboardDataObj) {
        var newPiChartData = piChartData;
        newPiChartData = {
            type: 'doughnut',
            labels: ['Time to Attend', 'Time to Resolution', 'Time to Completion', 'Time to Initial Call'],
            datasets: [
                {
                    data: [
                        dashboardDataObj.timeToAttend,
                        dashboardDataObj.timeToResolution,
                        dashboardDataObj.timeToCompletion,
                        dashboardDataObj.timeToInitialCall
                    ],
                    backgroundColor: [
                        '#294DB1',
                        '#6CB1D8',
                        '#ED6D57'
                    ],
                    borderWidth: 2
                }
            ]
        };
        setPiChartData(__assign({}, newPiChartData));
    };
    var columns = [
        {
            Header: 'Company Name',
            accessor: 'companyName'
        },
        {
            Header: 'Breach Type',
            accessor: 'breachType'
        },
        {
            Header: 'Ticket Title',
            accessor: 'ticketTitle'
        }
    ];
    var onLoad = function () {
        if (!isLoaded.customerList) {
            customer_1.fetchCustomers().then(function (data) {
                setList(data.list);
                var newIsLoaded = isLoaded;
                newIsLoaded.customerList = true;
                setIsLoaded(__assign({}, newIsLoaded));
            }).catch(console.error);
        }
        if (!isLoaded.dashboardData) {
            dashboard_1.dashboardBottom(parseInt(companyChart), activeBottomTab).then(function (response) {
                setDashboardData(response);
                updatePiChart(response);
                var newIsLoaded = isLoaded;
                newIsLoaded.dashboardData = true;
                setIsLoaded(__assign({}, newIsLoaded));
            }).catch(console.error);
        }
    };
    react_1.useEffect(function () {
        if (!isLoaded.customerList || !isLoaded.dashboardData) {
            onLoad();
        }
    }, [list, setList, isLoaded, setIsLoaded, dashboardData, setDashboardData, piChartData, setPiChartData]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "Bottom-Section" },
            React.createElement("div", { className: "card-header" },
                React.createElement("div", { className: "header-left" },
                    React.createElement("h6", { className: "card-title" }, "SLA Breach")),
                React.createElement("div", { className: "select-frequency" },
                    React.createElement(reactstrap_1.Button, { color: "", id: "Monthly-button", className: classnames_1.default({ active: activeBottomTab === 'monthly' }), onClick: function () { toggleBottom('monthly'); } }, "Monthly"),
                    React.createElement(reactstrap_1.Button, { color: "", className: classnames_1.default({ active: activeBottomTab === 'weekly' }), onClick: function () { toggleBottom('weekly'); } }, "Weekly"),
                    React.createElement(reactstrap_1.Button, { color: "", className: classnames_1.default({ active: activeBottomTab === 'today' }), onClick: function () { toggleBottom('today'); } }, "Today"))),
            React.createElement("div", { className: "Bottom-Container" },
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { lg: "4" },
                        React.createElement("div", { className: "Graph-Container" },
                            React.createElement("div", { className: "PieChart-header" },
                                React.createElement("h6", null, "SLA Breach")),
                            React.createElement("div", { className: "Pie-Chart" }, piChartData.datasets != null && piChartData.datasets.length > 0 ?
                                React.createElement(react_chartjs_2_1.Doughnut, { type: "doughnut", data: piChartData, options: {
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                display: false
                                            }
                                        }
                                    } }) : React.createElement(React.Fragment, null)),
                            React.createElement("div", { className: "PieChart-footer" },
                                React.createElement("h5", null,
                                    "RM",
                                    dashboardData.total),
                                React.createElement("p", null, "Cost Incurred with SLA Breaches")))),
                    React.createElement(reactstrap_1.Col, { lg: "8", className: "Graph-Container" },
                        React.createElement("div", { className: "Table-title" },
                            React.createElement("h6", null, "List of Breach")),
                        React.createElement("div", null,
                            React.createElement(PaginationTable_1.PaginationTable, { columns: columns, data: dashboardData.items }))))))));
};
exports.default = HomeBottomSection;
//# sourceMappingURL=HomeBottomSection.js.map